
import Vue from 'vue';
import Button from '@/components/Button/index.vue';

export default Vue.extend({
  components: {
    Button,
  },
  inject: ['userLogged', 'getStepDate'],
  data() {
    return {
      isDisabled: false,
      isLoading: true,
      isImgHidden: true,
      isOpenModalInfo: false,
      isOpenModalRepresentativeConfirmed: false,
      isOpenModalRepresentative: false,
    };
  },
  methods: {
    onConfirmedStepDetect() {
      this.isOpenModalInfo = true;
    },
    onSubmitRepresentive() {
      this.isOpenModalRepresentative = false;
      this.onNextStep();
    },
    onRepresentativeNotConfirmed() {
      this.isOpenModalRepresentativeConfirmed = false;
      this.onNextStep();
    },
    onNextStep() {
      this.getStepDate.currentStep += 1;
    },
    beforePageDestroyed(evt: BeforeUnloadEvent) {
      evt.preventDefault();
      // eslint-disable-next-line no-param-reassign
      evt.returnValue = '';
    },
  },
  mounted() {
    if (this.getStepDate.currentStep === 3) {
      window.addEventListener('beforeunload', this.beforePageDestroyed);
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforePageDestroyed);
  },
});
